/**
 * Aseli Main Product — quantity stepper + gallery thumbnail swap + mobile sticky ATC bar + back link guard.
 * (Details accordion moved to section-aseli-product-details.js.) Idempotent + shopify:section:load support.
 */
(function () {
  function initSection(root) {
    // Quantity stepper
    root.querySelectorAll('[data-amp-qty-step]').forEach(function (btn) {
      if (btn.getAttribute('data-amp-bound')) return;
      btn.setAttribute('data-amp-bound', '1');
      btn.addEventListener('click', function () {
        var form = btn.closest('[data-amp-add-form]');
        if (!form) return;
        var input = form.querySelector('[data-amp-qty-input]');
        var valEl = form.querySelector('[data-amp-qty-val]');
        var step = parseInt(btn.getAttribute('data-amp-qty-step'), 10) || 0;
        var val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val + step);
        input.value = val;
        if (valEl) valEl.textContent = val;
      });
    });

    // Gallery thumbnail swap (desktop)
    root.querySelectorAll('[data-amp-img]').forEach(function (btn) {
      if (btn.getAttribute('data-amp-bound')) return;
      btn.setAttribute('data-amp-bound', '1');
      btn.addEventListener('click', function () {
        var stage = root.querySelector('#amp-main-img');
        if (!stage) return;
        stage.src = btn.getAttribute('data-amp-img');
        root.querySelectorAll('.amp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // Mobile sticky add-to-cart bar: show once the buy row has scrolled past the
    // top of the viewport — never while it is visible, never before it is reached.
    var satc = root.querySelector('[data-amp-satc]');
    var buyrow = root.querySelector('.amp__buyrow');
    if (satc && buyrow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          satc.classList.toggle('is-visible', past);
        });
      }, { threshold: 0 }).observe(buyrow);
    }

    // Back link: use browser history when the visitor came from inside the
    // shop (document.referrer same-origin); otherwise keep the homepage
    // fallback href (direct entry via Google/newsletter must not leave the shop).
    root.querySelectorAll('[data-amp-back]').forEach(function (link) {
      if (link.getAttribute('data-amp-bound')) return;
      link.setAttribute('data-amp-bound', '1');
      link.addEventListener('click', function (e) {
        var internal = false;
        try {
          internal = !!document.referrer &&
            new URL(document.referrer, window.location.href).origin === window.location.origin;
        } catch (err) { /* malformed referrer -> keep fallback */ }
        if (internal && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.amp').forEach(initSection);
  }
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      initSection(event.target);
    }
  });
})();
